/**
 * User-facing brand strings for the marketing site (CRA).
 * Override per deploy via REACT_APP_BRAND_* env vars.
 */

const env = key => process.env[key]?.trim() || "";

export const BRAND = {
  short: env("REACT_APP_BRAND_SHORT") || "Phi",
  product: env("REACT_APP_BRAND_PRODUCT") || "PhiSqrd",
  domainLabel: env("REACT_APP_BRAND_DOMAIN_LABEL") || "PhiSqrd.com",
  legalEntity: env("REACT_APP_BRAND_LEGAL_ENTITY") || "The Buddyhood Platforms Ltd",
  appTitle: env("REACT_APP_BRAND_APP_TITLE") || "PhiSqrd",
  tagline: env("REACT_APP_BRAND_TAGLINE") || "A Mindful Network",

  urls: {
    marketing: env("REACT_APP_BRAND_URL_MARKETING") || "https://phisqrd.com",
    app: env("REACT_APP_BRAND_URL_APP") || "https://app.phisqrd.com",
    support: env("REACT_APP_BRAND_URL_SUPPORT") || "https://support.imprint.live/hc/en-us",
    instagram: env("REACT_APP_BRAND_URL_INSTAGRAM") || "https://www.instagram.com/imprint.live/",
    twitter: env("REACT_APP_BRAND_URL_TWITTER") || "https://twitter.com/imprintlive5",
    facebook:
      env("REACT_APP_BRAND_URL_FACEBOOK") ||
      "https://www.facebook.com/profile.php?id=61553164695687",
    linkedin:
      env("REACT_APP_BRAND_URL_LINKEDIN") || "https://www.linkedin.com/company/imprintlive/"
  },

  emails: {
    support: env("REACT_APP_BRAND_EMAIL_SUPPORT") || "support@phisqrd.co.uk",
    accessibility: env("REACT_APP_BRAND_EMAIL_ACCESSIBILITY") || "account@phisqrd.co.uk"
  },

  content: {
    singular: env("REACT_APP_BRAND_CONTENT_SINGULAR") || "Phi",
    plural: env("REACT_APP_BRAND_CONTENT_PLURAL") || "Phis",
    singularLower: env("REACT_APP_BRAND_CONTENT_SINGULAR_LOWER") || "phi",
    pluralLower: env("REACT_APP_BRAND_CONTENT_PLURAL_LOWER") || "phis"
  }
};
